import {
	IsArray,
	IsBoolean,
	IsNumber,
	IsOptional,
	IsString,
} from 'class-validator';
import type { StandardRegistrationFieldConfigDto } from '../../constants/registration-standard-fields';

// Re-export the effective-config shape so consumers can import it from the DTO
// barrel alongside the request/response types.
export type { StandardRegistrationFieldConfigDto };

// Trimmed shape the PUBLIC storefront needs to decide whether to render a
// standard field and whether to mark it required. No label — the storefront
// owns its own (translated) labels for the built-in fields.
export interface PublicStandardFieldDto {
	fieldKey: string;
	isVisible: boolean;
	isRequired: boolean;
}

// One field's desired config in an admin update.
export class StandardRegistrationFieldInputDto {
	@IsString()
	public fieldKey!: string;

	@IsBoolean()
	public isVisible!: boolean;

	@IsBoolean()
	public isRequired!: boolean;
}

// Admin PUT body: set the standard-field config for a scope (tenant default when
// portalSiteId omitted/null). Only known field keys are applied; the service
// upserts one row per provided field at the scope.
export class UpdateStandardRegistrationFieldsDto {
	@IsNumber()
	@IsOptional()
	public portalSiteId?: number | null;

	@IsArray()
	public fields!: Array<StandardRegistrationFieldInputDto>;
}

export type GetStandardRegistrationFieldsResponseDto =
	| { success: true; data: Array<StandardRegistrationFieldConfigDto> }
	| { success: false; error: string };

export type MutateStandardRegistrationFieldsResponseDto =
	| { success: true; data: Array<StandardRegistrationFieldConfigDto> }
	| { success: false; error: string };
